import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSelectedBusinessUnit } from 'contexts/SidebarContext';
import { type FC, useState } from 'react';
import { NAVY, RADIUS_COIN, SURFACE, SURFACE_CONTAINER_LOW } from 'styles/tokens';

import InsuranceCredentialsForBusinessUnit from './components/InsuranceCredentialsForBusinessUnit';

const InsuranceCredentials: FC = () => {
  const { selectedBusinessUnitId: businessUnitId } = useSelectedBusinessUnit();
  const [refetchFlag, setRefetchFlag] = useState<number>(0);

  return (
    <Box sx={{ backgroundColor: SURFACE, minHeight: '100vh', p: { xs: 2, md: 4 } }}>
      {businessUnitId ? (
        <InsuranceCredentialsForBusinessUnit
          businessUnitId={businessUnitId}
          onRefetch={() => setRefetchFlag(refetchFlag + 1)}
        />
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            backgroundColor: SURFACE_CONTAINER_LOW,
            borderRadius: RADIUS_COIN,
          }}
        >
          <Typography variant="h5" sx={{ fontFamily: 'Jost', color: NAVY, opacity: 0.5 }}>
            Selecciona una unidad de negocio para configurar las credenciales de seguros
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default InsuranceCredentials;
